module.exports = __webpack_public_path__ + "img/temperature.a6547055.png";